import React from 'react';
import {SectionDetail, Tabs, Tab, TabPanel, RaymanUser, Button} from 'components/core';
import {Grid} from '@material-ui/core';
import {ChannelsCtx, ChannelFilesCtx, ChannelFilesProvider} from 'components/dataProviders/channels';
import {UsersCtx} from 'components/dataProviders/users';
// import Singletons from 'controllers/Singletons';
import {Lock, LockOpen} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import Chat from './chat';
import FilesList from 'components/files/FilesList';

const styles = makeStyles((theme) => ({
  title: {
    color: theme.palette.text.secondary,
    fontSize: 15,
    fontWeight: 500,
    textTransform: "uppercase",
    margin: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}), {name: "RaymanChannelsPanel"});




export default function ChannelPanel({channelID, onClose = () => {}})
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const channelsCtx = React.useContext(ChannelsCtx);
    const usersCtx = React.useContext(UsersCtx);
    const channelData = channelsCtx.data.indexed[channelID];
    const classes = styles();
    const handleClose = () => {
        onClose();
    }

    function archive()
    {
      channelsCtx.funcs.disable(channelID);
    }

    function unarchive()
    {
      channelsCtx.funcs.enable(channelID);
    }

    if(!channelID || !channelData || usersCtx.loading) return null;

    const detailTabs = <Tabs value={selectedTab} onChange={(evt, index) => setSelectedTab(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Chat"/>
        <Tab label="Archivos"/>
    </Tabs>

    const channel = channelsCtx.data.indexed[channelID];

    const readonly = channel.currentUserRole === 'admin' || channel.closed;

    const header = <Grid container direction="row" spacing={2} justify="space-between">
      <Grid item className={classes.title}>{channelData.name}</Grid>
      <Grid item><Grid container direction="row" spacing={1}>
        {!channel.closed && channelData.isManager && <Grid item><Button color="error" fullWidth={false} onClick={()=>archive()}><Lock /></Button></Grid> }
        {channel.closed && channelData.isManager && <Grid item><Button color="secondary" fullWidth={false} onClick={()=>unarchive()}><LockOpen /></Button></Grid> }
      </Grid></Grid>
    </Grid>

    return <SectionDetail onCloseClick={() => handleClose()} tabs={detailTabs} header={header} >
    <TabPanel value={selectedTab} index={0}>
        <Chat channelData={channelData} readonly={readonly} />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <ChannelFilesProvider channelID={channelID}>
          <FilesList context={ChannelFilesCtx} editable/>
        </ChannelFilesProvider>
      </TabPanel>
  </SectionDetail>
}